import React, { useEffect, useRef, useState } from 'react';
import everpassLogo from '../../assets/everpassLogo.svg';
import suitcase from '../../assets/suitcase.svg';
import './VisualTestUpNext.scss';

const FOCUS_SKIP = 0;
const FOCUS_RUN = 1;

export default function VisualTestUpNext({ onRun, onSkip }) {
    const [focusIdx, setFocusIdx] = useState(FOCUS_RUN);
    const focusIdxRef = useRef(FOCUS_RUN);
    const skipRef = useRef(null);
    const runRef = useRef(null);

    const refs = [skipRef, runRef];

    // Focus the active button whenever focusIdx changes
    useEffect(() => {
        refs[focusIdx]?.current?.focus();
    }, [focusIdx]);

    useEffect(() => {
        const handleKey = (e) => {
            if (!['ArrowLeft', 'ArrowRight', 'Enter', ' ', 'Return', 'Accept'].includes(e.key)) return;
            e.stopPropagation();
            e.stopImmediatePropagation();
            e.preventDefault();

            if (e.key === 'ArrowLeft') {
                const next = Math.max(focusIdxRef.current - 1, 0);
                focusIdxRef.current = next;
                setFocusIdx(next);
            } else if (e.key === 'ArrowRight') {
                const next = Math.min(focusIdxRef.current + 1, 1);
                focusIdxRef.current = next;
                setFocusIdx(next);
            } else {
                focusIdxRef.current === FOCUS_RUN ? onRun() : onSkip();
            }
        };
        window.addEventListener('keydown', handleKey, { capture: true });
        return () => window.removeEventListener('keydown', handleKey, { capture: true });
    }, [onRun, onSkip]);

    return (
        <div className="VTUpNext" role="dialog" aria-modal="true" aria-label="Let's check your stream setup">
            <div className="VTUpNext__top">
                <p className="VTUpNext__eyebrow">
                    <img className="VTUpNext__eyebrow-icon" src={suitcase} alt="" aria-hidden="true" />
                    Streaming Readiness
                </p>
            </div>

            <div className="VTUpNext__body">
                <h1 className="VTUpNext__title">Let's check your stream setup</h1>
                <p className="VTUpNext__desc">
                    We'll check your video, audio, and captions so you're streaming ready.<br />
                    This test takes up to 30 minutes — you can skip and run it later.
                </p>
                <div className="VTUpNext__actions">
                    <button
                        ref={skipRef}
                        className={`VTUpNext__btn VTUpNext__btn--skip${focusIdx === FOCUS_SKIP ? ' VTUpNext__btn--focused' : ''}`}
                        onClick={onSkip}
                    >
                        Skip
                    </button>
                    <button
                        ref={runRef}
                        className={`VTUpNext__btn VTUpNext__btn--run${focusIdx === FOCUS_RUN ? ' VTUpNext__btn--focused' : ''}`}
                        onClick={onRun}
                    >
                        Check my setup
                    </button>
                </div>
            </div>

            <img className="VTUpNext__logo" src={everpassLogo} alt="EverPass" />
        </div>
    );
}
